import * as R from 'ramda'
import moment from "moment-timezone";

export const isNullOrEmpty = (value) => R.isEmpty(value) || R.isNil(value);

export const inNegative = (value) => value <= 0;

export const isGreaterThan100 = (value) => value > 100;

export const validateConcentration = (concentration: string)=>{
  return isNullOrEmpty(concentration) ? 'Por favor, Informe a concentração': 
  inNegative(concentration)?  'Por favor, Informe um número maior que 0':
  isGreaterThan100(concentration)?  'A concentração não pode ser maior que 100': undefined
};

export const validateValidityDate = (diasValidade: string)=>{
  return isNullOrEmpty(diasValidade) ? 'Por favor, Informe os dias de validade': 
            inNegative(diasValidade)?  'Por favor, Informe um número maior que 0': undefined
}


export const validateFabricationDate = (dataLote: string)=>{
  return isNullOrEmpty(dataLote) ? 'Por favor, Informe a data de fabricação':
    moment(dataLote).isAfter(new Date().toString())? 'A data de fabricação não pode ser maior que a data atual': undefined
}
